module.exports = __webpack_public_path__ + "static/media/catandbook-no-book.28ee89ea.gif";